export enum Status {
    REQUESTED = 'requested',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    CLAIMED = 'claimed',
}

export type Data = {
    organizationId: string;
    organizationName: string;
    requesterName: string;
    requesterEmail: string;
    requestedDate: string;
    status: Status;
    reviewerName?: string;
    reviewedDate?: string;
};

export type Order = 'asc' | 'desc';

export type TabPanelProps = {
    children?: React.ReactNode;
    index: number;
    value: number;
};

export type TabsComponentProps = {
    value: number;
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
    labels: string[];
};

export type TableComponentProps = {
    rows: Data[];
    order: Order;
    orderBy: keyof Data;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    numSelected: number;
    rowCount: number;
    page: number;
    rowsPerPage: number;
    emptyRows: number;
    onPageChange: (_: unknown, newPage: number) => void;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    status?: Status;
    onStatusChange?: (status: Status.APPROVED | Status.REJECTED, orgId: string) => void;
    comparator?: (a: Data, b: Data) => number;
};

export type EnhancedTableProps = {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
};

export type HeadCell = {
    disablePadding: boolean;
    id: keyof Data;
    label: string;
    numeric: boolean;
};
